import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LoginForm from 'components/LoginForm/LoginForm';
import FormContainer from 'uI/FormContainer/FormContainer';
import Submenu from 'uI/Submenu/Submenu';

import classes from './Course.module.css';

const Course = () => {
  const { academyName, idCourse } = useParams();
  const [sectionTab, setSectionTab] = useState('myCourses');
  const [courseIframe] = useState(
    `${process.env.REACT_APP_API_PATH_MAYAHII_URL}/${academyName}/course/${idCourse}`
  );
  const { t } = useTranslation(['login']);
  const dataUser = useSelector(state => state.userInfo);

  const changeSectionHandler = section => {
    setSectionTab(section);
  };

  return (
    <>
      {dataUser.data.systemDate &&
        (dataUser.data.usuario ? (
          <>
            <Submenu
              changeSection={changeSectionHandler}
              sectionTab={sectionTab}
              sectionTitle="Mi campus"
              section="myCampus"
              menu
            />
            <iframe
              src={courseIframe}
              className={classes.iframeContainer}
              frameBorder={0}
            />
          </>
        ) : (
          <FormContainer
            title={t('principal_text')}
            btnLink="register"
            login
          >
            <LoginForm prevUrl="myAccount/profile" />
          </FormContainer>
        ))}
    </>
  );
};

export default Course;
